<template>
    <form @submit.prevent="onSubmit" class="flex w-full lg:w-auto lg:flex-row flex-col items-center z-20 shadow-custom rounded-lg p-3 bg-white gap-2">
        <div class="flex w-full flex-1 lg:w-auto lg:flex-row flex-col gap-2" :class="$attrs.class">
            <Field class="w-full lg:flex-1 no-focus">
                <SearchFormLocation v-model:url="selectedUrl" v-model:q="params.q" />
            </Field>
            <Field class="w-full lg:w-54">
                <SearchFormDate v-model="params.startDate" @date-selected="nightsRef?.open()" />
            </Field>
            <Field class="w-full lg:w-48 no-focus">
                <SearchFormNights ref="nightsRef" v-model="params.nights" />
            </Field>
            <Field class="w-full lg:w-48">
                <div class="lg:hidden">
                    <SearchFormGuest v-model:adults="params.adults" v-model:children="params.children" />
                </div>
                <div class="hidden lg:block">
                    <SearchFormGuestPopover v-model:adults="params.adults" v-model:children="params.children" />
                </div>
            </Field>
        </div>
        <Button size="lg" severity="primary" class="lg:w-40" type="submit">{{ $t('Search') }}</Button>
    </form>
</template>

<script setup>
import SearchFormLocation from './SearchFormLocation.vue'
import SearchFormDate from './SearchFormDate.vue'
import SearchFormGuest from './SearchFormGuest.vue'
import SearchFormGuestPopover from './SearchFormGuestPopover.vue'
import SearchFormNights from './SearchFormNights.vue'

import { useProductsStore } from '@/stores/products'
import { useCraftNavigation } from '@/composables/useCraftNavigation'
import { buildProductsSearchQuery, buildCatalogListingQuery } from '@/composables/searchQuery'
import { storeToRefs } from 'pinia'

const store = useProductsStore()
const { params } = storeToRefs(store)
const { reloadToPath } = useCraftNavigation()

const nightsRef = ref(null)

// Set when the "Where?" picker resolves to a specific country/region/city/camp —
// navigate straight to its SEO listing path (/nastanitve/...) instead of
// /ponudbe?region_id=... etc. Seeded from the current page's own resolved
// context (if any) so re-submitting the form — e.g. after just changing
// dates, without touching "Where?" — keeps the same location instead of
// silently dropping it.
const selectedUrl = ref(store.context?.url ?? null)

const onSubmit = () => {
    if (selectedUrl.value) {
        reloadToPath('/nastanitve/' + selectedUrl.value, buildCatalogListingQuery(params.value))
        return
    }

    reloadToPath('/ponudbe', buildProductsSearchQuery(params.value))
}

defineOptions({
    inheritAttrs: false,
})
</script>
